import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Chip,
  Paper,
  Box,
} from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

const CertificateStatusStep = ({ formData, setFormData, isComplete }) => {
  const options = [
    {
      value: 'true',
      icon: <CheckCircleOutlineIcon sx={{ fontSize: 40 }} />,
      title: 'Onboard Existing Venafi Cert',
      description: 'The certificate already exists in Venafi and needs to be registered in CertManage.',
    },
    {
      value: 'false',
      icon: <AddCircleOutlineIcon sx={{ fontSize: 40 }} />,
      title: 'Create & Onboard a New Cert',
      description: 'Request and onboard a brand new certificate that does not yet exist in Venafi.',
    },
  ]

  return (
    <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Chip
            label={isComplete ? '✓' : '1'}
            color={isComplete ? 'success' : 'primary'}
            size="small"
          />
          Certificate Status
        </Typography>
        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          {options.map((opt) => {
            const selected = formData.preExisting === opt.value
            return (
              <Paper
                key={opt.value}
                elevation={selected ? 3 : 1}
                onClick={() => setFormData({ ...formData, preExisting: opt.value })}
                sx={{
                  flex: '1 1 200px',
                  p: 3,
                  cursor: 'pointer',
                  border: selected ? '2px solid' : '1px solid',
                  borderColor: selected ? 'primary.main' : 'grey.300',
                  borderRadius: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 1,
                  textAlign: 'center',
                  transition: 'all 0.2s ease',
                  '&:hover': { borderColor: 'primary.main' },
                }}
              >
                <Box sx={{ color: selected ? 'primary.main' : 'grey.500' }}>{opt.icon}</Box>
                <Typography variant="body1" sx={{ fontWeight: selected ? 600 : 400 }}>
                  {opt.title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {opt.description}
                </Typography>
              </Paper>
            )
          })}
        </Box>
      </CardContent>
    </Card>
  )
}

export default CertificateStatusStep
